export default __webpack_public_path__ + "dist/media/SavingTimes.e5aebe81.svg";